import { FeatureSettings } from 'models/types';
import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useFeatureSettings = (reactQueryOptions?: UseQueryOptions<FeatureSettings, Error>) =>
    useQuery(QueryKeys.FEATURE_SETTINGS, CuredApiPaths.FEATURE_SETTINGS, reactQueryOptions);

export default useFeatureSettings;
